import axios from 'axios'
import { IAuthenticationManager } from 'torqcloud-ui'

export function createApiClient(
  authenticationManager: IAuthenticationManager,
  baseURL: string,
  headers?: Record<string, string>,
  organizationId?: () => string | undefined
) {
  const apiClient = axios.create({ baseURL, headers })

  apiClient.interceptors.request.use(async function (config) {
    const userSession = await authenticationManager.currentSession()
    const idToken = userSession?.getIdToken()?.getJwtToken()
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`
    }

    if (organizationId) {
      const currentOrganizationId = organizationId()
      if (currentOrganizationId) {
        config.headers['x-organizationId'] = currentOrganizationId
      } else {
        delete config.headers['x-organizationId']
      }
    }

    return config
  })

  return apiClient
}
